import { React, useState, useEffect} from 'react'
import { FormSelect } from 'react-bootstrap';
import axios from 'axios';

// const DynamicDropDownComp = ({ apiURL, optionsProcessing, inputName, formik, formikName, labelName, customOnChangeEvents }) => {
const DynamicDropDownComp = (props) => {
    const [options, setOptions] = useState([]);
    // const [loading, setLoading] = useState(true);
    // const [error, setError] = useState(null);
    
    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const response = await axios.get(props.apiURL);
                setOptions(props.optionsProcessing(response.data));
            } catch (error) { } //setError(error.message);
            finally {  } //setLoading(false);
        }
        fetchOptions();
    }, []);

    return (
        <>
            { (props.labelName !== "" && props.labelName !== "undefined") && <label>{props.labelName}</label> }
                <FormSelect name={props.inputName} onChange={(e) => {
                    props.formik?.handleChange(e);
                    props.customOnChangeEvents(e);
                }} value={props.formik?.values[props.formikName]} style={{height:'45px'}}>
                    {options}
                </FormSelect>
            {(props.formik?.errors[props.formikName]) ? <span className="text-danger">{props.formik?.errors[props.formikName]}</span> : null}
        </>
    )
}

export default DynamicDropDownComp;